 <template>
  <div>
    <div class="" style="width: 100%">
      <div class="m10">
        <Word :value="value" :config="config" :ExamTicketList="ExamTicketList" :UserCount="UserCount" :CompleteCount="CompleteCount" :NoComplete="NoComplete" />
      </div>
      <div id="export-html" class="p2">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td colspan="8">{{ value.Title }}</td>
            </tr>
            <tr>
              <td colspan="2">企业名称</td>
              <td colspan="6">{{ value.Company.Name }}</td>
            </tr>
            <tr>
              <td colspan="2">培训周期</td>
              <td colspan="2">{{ ExamRange }}</td>
              <td colspan="2">考核时间</td>
              <td colspan="2">{{ ExamDate }}</td>
            </tr>
            <tr>
              <td colspan="3">培训主题</td>
              <td colspan="3">课件数量</td>
              <td>课件时长</td>
            </tr>
            <tr>
              <td colspan="3">{{ value.Title }}</td>
              <td colspan="3">{{ value.VideoCount }}</td>
              <td>{{ LessonsTimeLen || 0 }}</td>
            </tr>
            <tr>
              <td colspan="2">参加考试人数</td>
              <td colspan="4">考试通过人员</td>
              <td colspan="2">考试未通过人数</td>
            </tr>
            <tr>
              <td colspan="2">{{ UserCount }}</td>
              <td colspan="4">{{ CompleteCount }}</td>
              <td colspan="2">{{ NoComplete }}</td>
            </tr>
            <tr>
              <td>序号</td>
              <td>头像</td>
              <td>姓名</td>
              <td>性别</td>
              <td>身份证</td>
              <td>学习结果</td>
              <td colspan="2">分数</td>
            </tr>
            <template v-if="paginatedList.length">
              <tr v-for="(item, index) in paginatedList" :key="index + '_' + item.Id">
                <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                <td>
                  <img :src="$matrix.Config.ImageSite + (item.Users.FaceImage2 || item.Users.FaceImage)" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; border: 1px solid #ddd" v-if="item.Users.FaceImage2 || item.Users.FaceImage" />
                  <span v-else style="font-size: 12px; color: #999">无头像</span>
                </td>
                <td>{{ item.Users.NickName }}</td>
                <td>{{ item.Users.Sex === 1 ? '男' : '女' }}</td>
                <td>{{ item.Users.IDCard }}</td>
                <td>{{ item.ExamResult === 2 ? '通过' : '不通过' }}</td>
                <td colspan="2">{{ item.ExamScore }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- 分页控制区域 -->
        <div class="pagination" style="margin-top: 20px; text-align: center">
          <el-button :disabled="currentPage === 1" @click="currentPage--" size="small"> 上一页 </el-button>
          <span style="margin: 0 10px"> 第 {{ currentPage }} 页 / 共 {{ totalPages }} 页 </span>
          <el-button :disabled="currentPage === totalPages || totalPages === 0" @click="currentPage++" size="small"> 下一页 </el-button>
        </div>

        <div class="flex-row p2 f16">
          <div>所属单位安全教育培训管理部门签章：</div>
          <div class="rel">网络安全教育平台 <el-image src="/static/system/zhang.png" class="abs" /></div>
        </div>
        <div class="flex-row p2 end"></div>
        <div class="flex-row p2">
          <div class="wf end flex-row rel">{{ ExamDate }}</div>
          <div class="wf end flex-row rel">{{ ExamDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jsPDF as JsPDF } from 'jspdf'
import html2Canvas from 'html2canvas'
import Word from './Word.vue'
let axios = require('axios')

export default {
  props: {
    value: Object,
    config: Object
  },
  components: {
    Word
  },

  computed: {
    Users() {
      if (this.value && this.value.Users) {
        return this.value.Users
      }
    },

    ExamDate() {
      if (this.value) {
        return this.value.CreateTime.substr(0, 7)
      }
    },
    ExamRange() {
      if (this.value) {
        let Year = new Date(this.value.CreateTime).getFullYear(),
          Month = new Date(this.value.CreateTime).getMonth() + 1,
          Day = new Date(Year, Month, 0).getDate()

        return `${Year}年${Month > 9 ? Month : '0' + Month}月01日-${Year}年${Month > 9 ? Month : '0' + Month}月${Day}日`
      }
    },
    LessonsTimeLen() {
      if (this.value && this.value.LessonsList && this.value.LessonsList.length) {
        return this.getDuration(
          this.value.LessonsList.reduce((t, n) => {
            return (t += n.LearnTime)
          }, 0)
        )
      }
    },
    // 计算总页数
    totalPages() {
      return Math.ceil(this.ExamTicketList.length / this.pageSize) || 1
    },
    // 当前页数据切片
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.ExamTicketList.slice(start, end)
    }
  },
  data() {
    return {
      CompleteCount: 0,
      UserCount: 0,
      NoComplete: 0,
      Rate: '',
      ExamTicketList: [],
      // 分页相关参数
      currentPage: 1,
      pageSize: 10 // 每页显示10条，可根据需要调整
    }
  },
  methods: {
    test() {
      this.$matrix
        .Post3('Manager', '', { actname: 'test', content: '123' }, '', '', true, true)
        .then((res) => {
          console.log(res, 'res')
        })
        .catch((e) => {
          console.log(e, 'e')
        })
    },
    onDownLoad() {},
    async exportPDF() {
      const container = document.querySelector('#export-html')
      if (!container) return this.$matrix.ShowError('未找到导出容器')

      const canvas = await html2Canvas(container, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        logging: false
      })

      const contentWidth = canvas.width / 2
      const contentHeight = canvas.height / 2
      const PDF = new JsPDF('', 'pt', [contentWidth, contentHeight])
      const pageData = canvas.toDataURL('image/jpeg', 1.0)
      PDF.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight)
      PDF.save(document.title + '.pdf')
    },
    getDuration(seconds) {
      let m = Math.floor(seconds / 60)
      let s = Math.floor(seconds % 60)
      return `${m > 9 ? m : '0' + m}分${s > 9 ? s : '0' + s}秒`
    },
    LoadData() {
      this.$matrix
        .AjaxGet3(
          'Exam.Ticket',
          'GetList',
          {
            Page: 1,
            PageSize: 0,
            Training: this.value,
            GetUsers: true,
            GetParent: true,
            GetTraining: true,
            TrainingSearchParams: { GetLessonsList: true },
            ExamState: [2, 3]
          },
          this.config.Role,
          this.config.RoleField
        )
        .then((data) => {
          console.log('Doc2 LoadData 返回数据:', data)
          if (data.Items.length) {
            console.log('第一个用户的Users对象:', data.Items[0].Users)
            console.log('FaceImage2:', data.Items[0].Users?.FaceImage2, 'FaceImage:', data.Items[0].Users?.FaceImage)
            this.ExamTicketList = data.Items.sort((a, b) => {
              return b.ExamResult - a.ExamResult
            })
            this.UserCount = data.Items.length
            this.CompleteCount = data.Items.filter((item) => {
              return [2, 3].indexOf(item.ExamResult) > -1
            }).length
            this.NoComplete = this.UserCount - this.CompleteCount
            // 重置页码到第一页
            this.currentPage = 1
          }
        })
        .catch((e) => {
          this.$matrix.ShowError(e)
        })
    }
  },
  created() {
    console.log(this.value, '1')
    this.LoadData()
  }
}
</script>
<style scoped>
table {
  border: 2px solid #000;
}

table tr td {
  font-size: 16px !important;
  padding: 20px;
  border: 1px solid #000;
  text-align: center;
}

.rel {
  position: relative;
  z-index: 999;
}

.abs {
  position: absolute;
  right: 0;
  z-index: -1;
}
</style>